import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import AuthLayout, { AuthNotice } from './AuthLayout';

export default function AccountLoadError() {
  const { t } = useTranslation('auth');
  const { refreshAccount, logout } = useAuth();
  return <AuthLayout title={t('setup.loadTitle')} subtitle={t('setup.loadSubtitle')}>
    <AuthNotice>{t('setup.loadError')}</AuthNotice>
    <div className="auth-retry">
      <button className="auth-primary" type="button" onClick={refreshAccount}>{t('shared.retry')}</button>
      <button className="auth-text-button" type="button" onClick={logout}>{t('shared.signOut')}</button>
    </div>
  </AuthLayout>;
}
